var products = require("../_products");
var product_categories = require("../_product-categories");
var product_subcategories = require("../_product-subcategories");

var lang = window.location.pathname.split("/")[1].toLowerCase();

$(document).ready(function () {
	squareBoxRecentProduct();
	if ($("#recent-products").length && !$(".container-single-news").length) {
		var idProd = parseInt($("#product-info").data("product"));
		if (localStorage.recentProducts) {
			getRecentProduct();
		} else {
			$("#recent-products").remove();
		}
		addProductToLocal(idProd);
	}
	if ($(".container-single-news").length) {
		getRecentProduct();
	}
});

function cleanArray(actual) {
	var newArray = new Array();
	for (var i = 0; i < actual.length; i++) {
		if (actual[i]) {
			newArray.push(actual[i]);
		}
	}
	return newArray;
}

function getRecentProduct() {

	var arrRecentProducts = [];

	if ($(".container-single-news").length) {
		arrRecentProducts = featuredProduct
			.split("/,| /")
			.join("")
			.split(",");
	} else {
		arrRecentProducts = JSON.parse(localStorage.recentProducts);
	}

	var arrProd = [];
	arrRecentProducts = cleanArray(arrRecentProducts);

	arrRecentProducts.forEach(function (idProd, index) {

		if (index < 5 && idProd) {
			products.forEach(function (prod) {
				if (
					prod.id == idProd ||
					(typeof idProd == "string" && idProd.toLowerCase() == prod.slug)
				) {

					var catId = 0;
					if (prod.acf.category_id[0]) {
						catId = prod.acf.category_id[0].ID;
					}
					var catName = getCatName(catId, "cat");

					var subId = 0;
					if (prod.acf.sub_category_id[0]) {
						subId = prod.acf.sub_category_id[0].ID;
					}
					if (!subId) {
						return;
					}
					var subName = getCatName(subId, "sub");

					var link = "/" + lang + "/products/" + catId + "/" + catName[lang] + "/" + subId + "/" + subName[lang] + "/" + prod.acf.product_id;

					var obj = {
						name: prod.slug,
						link: link,
						img:
							"/images/" +
							prod.acf.category_id[0].post_name +
							"/" +
							prod.slug +
							"-300px.jpg" +
							"?prod_image_wp_url=" +
							prod.acf.product_image.url
					};
					arrProd.push(obj);
				}
			});
		}
	});
	var html = "";
	arrProd.forEach(function (prod) {
		html +=
			'<div class="recent-prod-box"><a href="' +
			prod.link +
			'"><div class="flex-col-center"><div class="img-product"><div class="img-bg" style="background-image: url(' +
			prod.img +
			')"></div></div><div class="name-prod"><span>' +
			prod.name.toUpperCase() +
			"</span></div></div></a></div></div>";
	});
	$(".recent-product-container, .featured-product-container").html("");
	$(".recent-product-container, .featured-product-container").append(html);
	squareBoxRecentProduct();
}

function getCatName(id, what) {
	var obj = {};
	switch (what) {
		case "cat":
			product_categories.forEach(function (cate) {

				if (cate.id == id) {

					var catLinkEn = cate.acf.category_name_en
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');
					var catLinkIt = cate.acf.category_name_it
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');

					obj = {
						it: catLinkIt,
						en: catLinkEn,
					};

				}
			});
			break;

		case "sub":

			product_subcategories.forEach(function (sub) {

				if (sub.id == id) {

					var catLinkEn = sub.acf.sub_category_name_en
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');
					var catLinkIt = sub.acf.sub_category_name_it
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');

					obj = {
						it: catLinkIt,
						en: catLinkEn,
					};

				}
			});
			break;
		default:
	}

	return obj;
}
function addProductToLocal(id) {
	if (localStorage.recentProducts) {
		var arrRecentProducts = JSON.parse(localStorage.recentProducts);
		var boolPush = true;
		arrRecentProducts = cleanArray(arrRecentProducts);
		for (var i = 0; i < arrRecentProducts.length; i++) {
			if (id == arrRecentProducts[i] && i < 5) {
				boolPush = false;
			}
		}
		if (boolPush) {
			arrRecentProducts.unshift(id);
			localStorage.recentProducts = JSON.stringify(arrRecentProducts);
		}
	} else {
		var arr = [id];
		localStorage.recentProducts = JSON.stringify(arr);
	}
}
$(window).on("resize", function () {
	squareBoxRecentProduct();
});
function squareBoxRecentProduct() {
	var height = $(".recent-prod-box").width();
	$(".recent-prod-box .img-product").each(function () {
		$(this).height(height - 14);
	});
}



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_recent-products.js
// module id = 16
// module chunks = 0